import * as React from 'react';
import './style.scss'

export interface IAlertMessageProps {
  message: string,
  show: boolean
}


export default class AlertMessage extends React.Component<IAlertMessageProps> {

  public render() {
    return (
      <div className={`alert-message ${this.props.show ? '' : 'display-none'}`}>
        {this.props.message}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AlertMessage/index.tsx